import React, {Fragment, useEffect, useState} from 'react';
import {Card} from "primereact/card";
import useApi from "../../../hooks/useApi";
import {useParams} from "react-router-dom";
import {webInfo} from "../../../utils/webInfo";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Dialog} from "primereact/dialog";
import Loader from "../../../Loader/Loader";
import moment from "moment";

const Inbox = () => {
    const {id} = useParams();
    const [inbox, setInbox] = useState<any>([]);
    const {get,loading} = useApi<any>();

    useEffect(() => {
        const link = `${webInfo.baseUrl}/api/admin/careers/${id}`;
        const fetchCareer = async () => {
            try {
                const res: any = await get(link);
                if(res.success){
                    setInbox(res.data.apply);
                }
            } catch (err) {
                console.error("Failed to fetch product", err);
            }
        };

        fetchCareer();
        // eslint-disable-next-line
    }, [id]);

    const [selectedLetter, setSelectedLetter] = useState("");
    const [visible, setVisible] = useState(false);

    const openCoverLetter = (rowData:any) => {
        setSelectedLetter(rowData.cover_letter);
        setVisible(true);
    };

    const coverLetterBody = (rowData:any) => {
        return (
            <Button
                label="View"
                icon="pi pi-eye"
                size={'small'}
                onClick={() => openCoverLetter(rowData)}
            />
        );
    };

    const cvBody = (rowData:any) => {
        return (
            <a href={`${webInfo.baseUrl}/${rowData.file}`} target="_blank" rel="noopener noreferrer">
                <img
                    alt="Default"
                    src={`/pdf.jpg`} height="50"/>
            </a>
        );
    };

    const dateBody = (rowData: any) => {
        const m = moment(rowData.created_at);
        return <span>{m.isValid() ? m.format("LL") : "-"}</span>;
    };


    const content = (
        <Fragment>
            <DataTable value={inbox} tableStyle={{minWidth: "60rem"}}>
                <Column field="name" header="Name"/>
                <Column field="email" header="Email"/>
                <Column field={"created_at"} header={"Applied On"} body={dateBody}/>
                <Column header="CV Attachment" body={cvBody}/>
                <Column header="Cover Letter" body={coverLetterBody}/>
            </DataTable>

            <Dialog
                header="Cover Letter"
                visible={visible}
                style={{width: "25vw"}}
                onHide={() => setVisible(false)}
            >
                <p>{selectedLetter}</p>
            </Dialog>
        </Fragment>
    )

    return (
        <Card title={'Inbox'}>
            {loading ? <Loader/> : content}
        </Card>
    );
};

export default Inbox;